<template>
    <div
        v-if="!isEditing"
        class="w-100"
    >
        <div class="map-item-filter">
            <div
                class="col-sm-12 nopads vehicle-list"
                :class="{ list_closed: !listOpen }"
            >
                <span
                    class="vehicle-list-title"
                    @click.stop="toggleList"
                >
                    {{ $t('menu.areas') }}
                </span>
                <div
                    class="vehicle-list-caret"
                    :class="{ caret_open: listOpen }"
                    @click.stop="toggleList"
                >
                    <font-awesome-icon icon="caret-down" />
                </div>

                <div
                    class="col-sm-12 nopads map-accordion-content"
                    :class="{ 'map-accordion-open': listOpen }"
                >
                    <!-- History Slider -->
                    <div class="col-12 px-2">
                        <div class="row nopads">
                            <div class="col-sm-8">
                                <span class="text-light">{{ $t('menu.area_work') }}</span>
                            </div>
                            <div class="col-sm-4 d-flex justify-content-end">
                                <span class="vehicle-list-no-results nopads text-end">{{ days + ' ' + 'd' }}</span>
                            </div>
                        </div>
                        <input
                            id="range"
                            v-model="days"
                            type="range"
                            class="form-range mb-2"
                            :min="minDays"
                            :max="maxDays"
                            :disabled="selectedTypes.length < 1 && !contractSelected"
                            @change="fetchAreaWork"
                        >
                    </div>
                    <hr
                        class="nopads px-2 mb-2 "
                        style="border-color: #5d6754"
                    >
                    <div class="map-select-item">
                        <!-- Select All Checkbox -->
                        <div class="form-check">
                            <input
                                id="checkboxAllAreas"
                                v-model="allSelected"
                                type="checkbox"
                                class="form-check-input"
                                :disabled="loading"
                                @change="toggleAll"
                            >
                            <label
                                class="form-check-label text-light"
                                for="checkboxAllAreas"
                            >
                                {{ allSelected ? $t('areas.deselect_all') : $t('areas.select_all') }}
                            </label>
                        </div>

                        <!-- Show Labels Checkbox -->
                        <div
                            v-if="!hideNameToggle"
                            class="form-check mt-1"
                        >
                            <input
                                id="checkboxShowLabels"
                                v-model="showLabels"
                                type="checkbox"
                                class="form-check-input"
                                :disabled="loading"
                                @change="$emit('areaLabelsChanged', showLabels)"
                            >
                            <label
                                class="form-check-label text-light"
                                for="checkboxShowLabels"
                            >
                                {{ $t('areas.show_labels') }}
                            </label>
                        </div>
                    </div>
                    <div class="map-select-item">
                        <!-- Check box for select/ unselect types -->
                        <span class="text-light">{{ $t('areas.type_select_hint') }}</span>
                        <div :class="{ 'disabled': loading }">
                            <!-- Form Group (custom wrapper with disabled state) -->
                            <div class="row nopads">
                                <div
                                    v-for="(option, index) in areaTypes"
                                    :key="index"
                                    class="col-6 nopads pr-1"
                                >
                                    <!-- Checkbox for each area type -->
                                    <div class="form-check form-check-sm">
                                        <input
                                            id="checkbox{{ index }}"
                                            v-model="selectedTypes"
                                            type="checkbox"
                                            :value="option.value"
                                            class="form-check-input"
                                            :disabled="loading"
                                        >
                                        <label
                                            class="form-check-label text-light"
                                            :for="'checkbox' + index"
                                        >
                                            {{ option.text }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {mapHelper} from "@/components/mixins/MapMixin";

export default {
    name: 'MapAreaSelector',
    mixins: [restApi, mapHelper],
    props: {
        getWorkRecords: {
            type: Boolean,
            default: false
        },
        contractSelected: {
            type: Boolean,
            default: false
        },
        hideBadges: {
            type: Boolean,
            default: false
        },
        hideNameToggle: {
            type: Boolean,
            default: false
        },
        contracts: {
            type: Array,
            default() {
                return []
            }
        },
        taskTypes: {
            type: Array,
            default() {
                return []
            }
        },
        order: {
            type: Object,
            default() {
                return null
            }
        },
        fetchEquipments: {
            type: Boolean,
            default: true
        },
        isEditing: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            areaTypes: [],
            loading: false,
            selectedTypes: [],
            listOpen: false,
            allSelected: false,
            showLabels: false,
            areaResults: [],
            areaWorkResults: [],
            days: 0,
            minDays: 0,
            maxDays: 30,
            debounceTimer: null
        }
    },
    watch: {
        contracts() {
            this.fetchAreas()
        },
        taskTypes() {
            this.fetchAreas()
        },
        order() {
            this.fetchAreas()
        },
        selectedTypes: function () {
            if (this.selectedTypes.length > 0) {
                this.fetchAreas()
            } else {
                this.areaResults = []
                this.$emit('areaSelectionChanged', [], [], [])
            }
        }
    },
    mounted: function () {
        this.fetchAreaTypes()
    },
    methods: {

        sortTypeEntries: function () {
            this.areaTypes.sort(function (a, b) {
                if (a.text < b.text) {
                    return -1;
                }
                if (a.text > b.text) {
                    return 1;
                }
                return 0;
            });
        },

        toggleList: function () {
            this.listOpen = !this.listOpen
        },

        toggleAll(event) {
            this.selectedTypes = []
            if (event.target.checked) {
                this.areaTypes.forEach(item => {
                    this.selectedTypes.push(item.value)
                })
            }
        },

        fetchAreaTypes: function () {
            this.loading = true
            this.restFetch(this.areaTypeUrl, this.handleAreaTypesResponse)
        },

        handleAreaTypesResponse: function (response) {
            this.loading = false
            this.areaTypes = []
            response.data.forEach(type => {
                this.areaTypes.push({value: type.id, text: type.name})
            })
            this.sortTypeEntries()
        },

        fetchAreas: function () {
            const params = {}
            this.areaResults = []
            this.areaWorkResults = []
            params.equipment = this.fetchEquipments
            params.types = this.selectedTypes
            if (this.contracts) {
                params.contractIds = this.contracts
            }
            if (params.types.length > 0) {
                this.loading = true
                this.restFetchParams(this.areaUrl, params, this.handleAreaResults)
            } else {
                this.$emit('areaSelectionChanged', this.selectedTypes, this.areaResults, this.areaWorkResults)
            }
        },

        handleAreaResults: function (response) {
            this.loading = false
            if (response && response.data) {
                this.areaResults = response.data
                if (this.areaResults.length > 0 && this.getWorkRecords) {
                    this.fetchAreaWork()
                } else {
                    this.$emit('areaSelectionChanged', this.selectedTypes, this.areaResults, this.areaWorkResults)
                }
            }
        },

        fetchAreaWork: function () {
            if (this.areaResults.length > 0) {
                this.areaWorkResults = []
                if (this.days > 0) {
                    this.loading = true
                    const params = {}
                    const today = new Date()
                    const fromTime = new Date(today.getTime() - this.days * 24 * 60 * 60 * 1000)
                    params.from = fromTime.toISOString()
                    if (this.contracts) {
                        params.contractIds = this.contracts
                    }
                    if (this.order) {
                        params.order = this.order.id
                    } else if (this.taskTypes) {
                        params.taskTypes = this.taskTypes.map(item => item.value)
                    }
                    this.restFetchParams(this.areaWorkUrl, params, this.handleAreaWorkResults)
                } else {
                    this.$emit('areaSelectionChanged', this.selectedTypes, this.areaResults, this.areaWorkResults)
                }
            }
        },

        handleAreaWorkResults(response) {
            this.loading = false
            if (response && response.data) {
                this.areaWorkResults = response.data
            }
            this.$emit('areaSelectionChanged', this.selectedTypes, this.areaResults, this.areaWorkResults)
        },

        handleGroupResults: function (response) {
            if (response && response.data) {
                // Loop through area groups areas and add the to results
                let areaGroups = response.data
                areaGroups.forEach(item => {
                    item.areas.forEach(area => {
                        if (!this.areaResults.find(item => item.id === area.id)) {
                            this.areaResults.push(area)
                        }
                    })
                });
                if (this.areaResults.length > 0 && this.getWorkRecords) {
                    this.fetchAreaWork()
                } else {
                    this.$emit('areaSelectionChanged', this.selectedTypes, this.areaResults, this.areaWorkResults)
                }
            }
            this.loading = false
        },

        getAreaTypes() {
            return this.areaTypes
        }

    }
}
</script>
